<template>
    <div class="internship-global-settings">
        <b-tabs
            class="internship-global-settings-tab apprentice-tab"
            content-class="internship-index-content">
            <!--            <b-tab title="Alle stages" >-->
            <!--                <design-2021-internships-index-all-tab-component-->
            <!--                    :internships-in="allInternships"-->
            <!--                    :internship-tags-in="internshipTags"-->
            <!--                    :google-map-api="googleMapApi">-->
            <!--                </design-2021-internships-index-all-tab-component>-->
            <!--            </b-tab>-->
            <b-tab
                :title="`${$authUser.school.name} stages`"
                active>
                <design-2021-internships-index-school-tab-component
                    :internships-in="schoolInternships"
                    :internship-tags-in="internshipTags"
                    :internship-duration-tags-in="internshipDurationTagsIn">
                </design-2021-internships-index-school-tab-component>
            </b-tab>
            <!--            <b-tab title="Persoonlijke stages">-->
            <!--                <design-2021-internships-index-personal-tab-component-->
            <!--                    :internships-in="personalInternships"-->
            <!--                    @acceptInternship="acceptPersonalInternship($event)"-->
            <!--                    @deleteInternship="deleteInternship($event)"-->
            <!--                >-->
            <!--                </design-2021-internships-index-personal-tab-component>-->
            <!--            </b-tab>-->
            <b-tab :title="$t('internship.internship_type')">
                <design-2021-internships-index-tags-tab-component :internship-tags-in="internshipTags">
                </design-2021-internships-index-tags-tab-component>
            </b-tab>
            <b-tab :title="$t('internship.administrators')">
                <design-2021-internships-index-management-tab-component :managers-in="managersIn">
                </design-2021-internships-index-management-tab-component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { ords } from '../../app';

const internshipOrds = ords.use('internship');
const internshipTagOrds = ords.use('internshipTag');
export default {
    name: 'design-2021-internships-index-component',
    props: {
        internshipsIn: Array,
        internshipTagsIn: Array,
        internshipDurationTagsIn: Array,
        managersIn: Array,
        googleMapApi: String,
    },
    data() {
        return {
            internships: [],
            internshipTags: [],
        };
    },
    computed: {
        allInternships() {
            return this.internships;
        },

        schoolInternships() {
            return this.allInternships.filter(
                (internship) => internship.internship_ownerable_type === 'App\\Models\\School',
            );
        },
        // personalInternships() {
        //     return this.internships.filter((internship) => internship.ownerable_type === "App\Models\User");
        // },
    },
    mounted() {
        internshipOrds.add(this.internshipsIn);
        internshipOrds
            .with('internship_duration_tags')
            .with('internship_tags')
            .get()
            .subscribe((internships) => {
                this.internships = internships;
            });
        internshipTagOrds.add(this.internshipTagsIn);
        internshipTagOrds.get().subscribe((tag) => {
            this.internshipTags = tag;
        });
    },
};
</script>

<style scoped lang="scss">
.internship-global-settings-tab ::v-deep {
    .nav-tabs {
        align-items: flex-end;
        flex-wrap: wrap;

        .progress-tab {
            margin-right: 0;
        }

        .nav-item {
            border-radius: 4px;
            background-color: $primary;
            flex: 1 0 100%;

            &:first-child {
                .nav-link {
                    padding-left: map-get($grid-gutter-spacing, 'fifteen');
                }
            }

            &:not(:last-of-type) {
                margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            }
        }

        .nav-link {
            padding: map-get($grid-gutter-spacing, 'ten') 0 map-get($grid-gutter-spacing, 'ten')
                map-get($grid-gutter-spacing, 'fifteen');

            color: $white;

            &:after {
                display: none;
            }
        }

        .last-tab {
            display: flex;
            flex: 1;
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .internship-global-settings-tab ::v-deep {
        .nav-tabs {
            align-items: baseline;
            flex-wrap: nowrap;

            .nav-item {
                border-radius: 0;
                background-color: transparent;
                flex: 0 0 auto;

                &:not(:last-of-type) {
                    margin-bottom: 0;
                }

                &:first-child {
                    padding-left: 0;
                }
            }

            .nav-link {
                padding: 0 map-get($grid-gutter-spacing, 'fifteen');
                color: $primary;

                &:after {
                    display: block;
                }
            }

            .last-tab {
                margin-bottom: 0;
                align-self: center;
            }
        }
    }
}
</style>
